import React from "react"

import {PaymentCurrencyType} from "@irati/types"
import {FormattedCurrency} from "@irati/utils/lang"
import {FormattedCurrencyProps} from "@irati/utils/lang/common/FormattedCurrency"
import {StyledLabel, StyledLabelProps} from "../style"

type PriceProps = StyledLabelProps &
  Pick<FormattedCurrencyProps, "style" | "value"> & {
    currency: PaymentCurrencyType
  }

const getDecimal = (val: number, isPercent: boolean) => {
  if (isPercent) return 4

  return Number.isInteger(val) ? 0 : 2
}

const Price = ({value, currency, style = "currency", ...props}: PriceProps) => {
  const val = Number(value)
  const isPercent = style === "percent"
  const decimal = getDecimal(val, isPercent)

  return (
    <StyledLabel currency={currency} {...props}>
      {<FormattedCurrency value={val} currency={currency} isCents={isPercent} maximumFractionDigits={decimal} style={style} />}
    </StyledLabel>
  )
}

export default Price
